import { useState, useEffect } from 'react';
import API, { SERVER_URL } from '../../api/axios';
import AppLayout from '../../components/layout/AppLayout';
import { S } from '../../components/pageStyles';
import { Loader } from '../../components/ui';
import { LuBeer, LuCamera, LuCircleCheck, LuClock, LuDroplet, LuFileText, LuFlame, LuLightbulb, LuMilk, LuMinus, LuPackage, LuPalette, LuPencil, LuPlus, LuRefreshCw, LuRuler, LuScissors, LuShirt, LuSoup, LuSparkles, LuStore, LuTag, LuThermometer, LuTimer, LuTrash2, LuTriangleAlert, LuUser, LuUtensils, LuWallet, LuWeight } from 'react-icons/lu';

import { fmtF } from '../../theme';
const CONFIGS = {
  boissons: {
    icon: <LuBeer aria-hidden />, label: 'Boissons', couleur: '#EA580C', bg: '#FFF7ED',
    categories: ['Bières', 'Vins', 'Spiritueux', 'Softs', 'Eaux', 'Jus', 'Champagnes', 'Autres'],
    unites: ['Bouteille', 'Cannette', 'Casier', 'Carton', 'Litre', 'Pack'],
    champs: [
      { nom: 'Volume', placeholder: '33cl, 50cl, 1L...', icon: <LuRuler aria-hidden /> },
      { nom: 'Température', placeholder: 'Frais, Ambiant...', icon: <LuThermometer aria-hidden /> },
      { nom: 'Contenant', placeholder: 'Verre, Plastique...', icon: <LuMilk aria-hidden /> },
    ]
  },
  restaurant: {
    icon: <LuUtensils aria-hidden />, label: 'Restaurant', couleur: '#0E7490', bg: '#ECFEFF',
    categories: ['Entrées', 'Plats principaux', 'Desserts', 'Boissons', 'Accompagnements', 'Autres'],
    unites: ['Portion', 'Plat', 'Unité', 'Kg'],
    champs: [
      { nom: 'Temps préparation', placeholder: '15 min, 30 min...', icon: <LuTimer aria-hidden /> },
      { nom: 'Ingrédients', placeholder: 'Poulet, tomates...', icon: <LuSoup aria-hidden /> },
      { nom: 'Disponibilité', placeholder: 'Midi, Soir, Toujours...', icon: <LuClock aria-hidden /> },
    ]
  },
  vetements: {
    icon: <LuShirt aria-hidden />, label: 'Vêtements', couleur: '#7C3AED', bg: '#F5F3FF',
    categories: ['Hauts', 'Bas', 'Robes', 'Chaussures', 'Accessoires', 'Autres'],
    unites: ['Pièce', 'Lot', 'Paire', 'Set'],
    champs: [
      { nom: 'Taille', placeholder: 'S, M, L, XL, 38, 40...', icon: <LuRuler aria-hidden /> },
      { nom: 'Couleur', placeholder: 'Rouge, Bleu, Noir...', icon: <LuPalette aria-hidden /> },
      { nom: 'Matière', placeholder: 'Coton, Polyester...', icon: <LuScissors aria-hidden /> },
      { nom: 'Genre', placeholder: 'Homme, Femme, Mixte...', icon: <LuUser aria-hidden /> },
    ]
  },
  cosmetiques: {
    icon: <LuSparkles aria-hidden />, label: 'Cosmétiques', couleur: '#BE185D', bg: '#FDF2F8',
    categories: ['Soins visage', 'Soins corps', 'Maquillage', 'Parfums', 'Cheveux', 'Autres'],
    unites: ['Flacon', 'Tube', 'Pot', 'Unité', 'Kit'],
    champs: [
      { nom: 'Marque', placeholder: "L'Oréal, Nivea...", icon: <LuTag aria-hidden /> },
      { nom: 'Type peau', placeholder: 'Sèche, Grasse, Mixte...', icon: <LuDroplet aria-hidden /> },
      { nom: 'Contenance', placeholder: '200ml, 50g...', icon: <LuPackage aria-hidden /> },
    ]
  },
  gaz: {
    icon: <LuFlame aria-hidden />, label: 'Gaz Butane', couleur: '#C2410C', bg: '#FFF7ED',
    categories: ['Bouteille 6kg', 'Bouteille 12kg', 'Bouteille 25kg', 'Détendeur', 'Tuyau', 'Accessoires'],
    unites: ['Bouteille', 'Pièce', 'Unité'],
    champs: [
      { nom: 'Poids', placeholder: '6kg, 12kg, 25kg...', icon: <LuWeight aria-hidden /> },
      { nom: 'Marque', placeholder: 'SIR GAZ, TOTAL GAZ...', icon: <LuTag aria-hidden /> },
      { nom: 'État', placeholder: 'Pleine, Vide, Consignée...', icon: <LuRefreshCw aria-hidden /> },
      { nom: 'Consigne', placeholder: 'Oui, Non...', icon: <LuWallet aria-hidden /> },
    ]
  },
  general: {
    icon: <LuStore aria-hidden />, label: 'Général', couleur: '#475569', bg: '#F1F5F9',
    categories: ['Alimentation', 'Électronique', 'Papeterie', 'Ménager', 'Autres'],
    unites: ['Unité', 'Pièce', 'Lot', 'Carton', 'Kg'],
    champs: []
  }
};

export default function ProduitsProprietaire() {
  const [etablissements, setEtablissements] = useState([]);
  const [etabSelectionne, setEtabSelectionne] = useState(null);
  const [secteurStock, setSecteurStock] = useState('general');
  const [produits, setProduits] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [vue, setVue] = useState('liste');
  const [produitSelectionne, setProduitSelectionne] = useState(null);
  const [message, setMessage] = useState('');
  const [recherche, setRecherche] = useState('');
  const [modalAppro, setModalAppro] = useState(null);
  const [modalPerte, setModalPerte] = useState(null);
  const [qteAppro, setQteAppro] = useState('');
  const [motifAppro, setMotifAppro] = useState('');
  const [qtePerte, setQtePerte] = useState('');
  const [motifPerte, setMotifPerte] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFichier, setImageFichier] = useState(null);
  const [champsExtra, setChampsExtra] = useState({});
  const [etape, setEtape] = useState(1);

  const [form, setForm] = useState({
    nom: '', description: '', prix: '',
    quantite: '', seuil_alerte: '',
    unite: '', categorie: ''
  });

  const chargerDonnees = async () => {
    try {
      const etabRes = await API.get('/etablissements');
      const etabs = etabRes.data.etablissements || [];
      setEtablissements(etabs);
      if (etabs.length > 0) {
        const premier = etabs[0];
        setEtabSelectionne(premier.id);
        setSecteurStock(premier.secteur_stock || 'general');
        await chargerProduits(premier.id);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setChargement(false);
    }
  };

  const chargerProduits = async (etabId) => {
    try {
      const res = await API.get('/produits?etablissement_id=' + etabId);
      setProduits(res.data.produits || []);
    } catch (err) {
      console.error(err);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { chargerDonnees(); }, []);

  const config = CONFIGS[secteurStock] || CONFIGS.general;

  const handleSelectEtab = (etab) => {
    setEtabSelectionne(etab.id);
    setSecteurStock(etab.secteur_stock || 'general');
    chargerProduits(etab.id);
    setVue('liste');
    resetForm();
  };

  const resetForm = () => {
    const cfg = CONFIGS[secteurStock] || CONFIGS.general;
    setForm({ nom: '', description: '', prix: '', quantite: '', seuil_alerte: '5', unite: cfg.unites[0], categorie: '' });
    setImagePreview(null);
    setImageFichier(null);
    setProduitSelectionne(null);
    setChampsExtra({});
    setEtape(1);
  };

  const handleModifier = (produit) => {
    setProduitSelectionne(produit);
    setForm({
      nom: produit.nom || '',
      description: produit.description || '',
      prix: produit.prix || '',
      quantite: produit.quantite || '',
      seuil_alerte: produit.seuil_alerte || '5',
      unite: produit.unite || config.unites[0],
      categorie: produit.categorie || ''
    });
    if (produit.image_principale) {
      setImagePreview(SERVER_URL + '/uploads/produits/' +
        produit.image_principale.replace(/\\/g, '/').split('/').pop());
    }
    setChampsExtra({});
    setEtape(1);
    setVue('formulaire');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { ...form, etablissement_id: etabSelectionne, ...champsExtra };
      const formData = new FormData();
      Object.keys(data).forEach(key => { if (data[key] !== '') formData.append(key, data[key]); });
      if (imageFichier) formData.append('image_principale', imageFichier);

      if (produitSelectionne) {
        await API.put('/produits/' + produitSelectionne.id, Object.fromEntries(formData));
        setMessage('✅ Produit modifié !');
      } else {
        await API.post('/produits', formData);
        setMessage('✅ Produit créé !');
      }
      chargerProduits(etabSelectionne);
      setVue('liste');
      resetForm();
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  const handleApprovisionner = async () => {
    if (!qteAppro || qteAppro <= 0) return;
    try {
      await API.post('/produits/' + modalAppro.id + '/approvisionner', {
        quantite: parseInt(qteAppro), motif: motifAppro
      });
      setMessage('✅ Stock approvisionné !');
      setModalAppro(null); setQteAppro(''); setMotifAppro('');
      chargerProduits(etabSelectionne);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  const handlePerte = async () => {
    if (!qtePerte || qtePerte <= 0) return;
    try {
      await API.post('/produits/' + modalPerte.id + '/perte', {
        quantite: parseInt(qtePerte), motif: motifPerte
      });
      setMessage('✅ Perte enregistrée !');
      setModalPerte(null); setQtePerte(''); setMotifPerte('');
      chargerProduits(etabSelectionne);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  const etabActuel = etablissements.find(e => e.id === etabSelectionne);
  const produitsFiltres = produits.filter(p =>
    p.nom.toLowerCase().includes(recherche.toLowerCase())
  );

  if (chargement) return <Loader />;

  return (
    <AppLayout role="proprietaire">

      {/* CONTENU */}
      <div style={styles.contenu}>

        {message && (
          <div role="status" style={{
            ...styles.messageBox,
            background: message.startsWith('✅') ? '#ECFDF5' : '#FEF2F2',
            color: message.startsWith('✅') ? '#047857' : '#B91C1C'
          }}>{message.replace(/^(✅|❌|⚠️)\s*/, '')}</div>
        )}

        {/* HEADER */}
        <div style={styles.header}>
          <div>
            <h1 style={styles.headerTitre}>Mes Produits</h1>
            <p style={styles.headerSousTitre}>
              {etabActuel
                ? etabActuel.nom + ' · ' + config.label + ' · ' + produits.length + ' produit(s)'
                : 'Sélectionnez un établissement'}
            </p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {vue !== 'liste' && (
              <button onClick={() => { setVue('liste'); resetForm(); }} style={styles.boutonRetour}>← Retour</button>
            )}
            {vue === 'liste' && etabSelectionne && (
              <button onClick={() => { resetForm(); setVue('formulaire'); }} style={styles.boutonAjouter}>
                + Nouveau Produit
              </button>
            )}
          </div>
        </div>

        {/* SÉLECTEUR ÉTABLISSEMENT */}
        <div style={styles.etabSelector}>
          <div style={styles.etabSelectorTitre}>Établissement</div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {etablissements.map((etab, i) => {
              const cfg = CONFIGS[etab.secteur_stock] || CONFIGS.general;
              return (
                <div key={i} onClick={() => handleSelectEtab(etab)} style={{
                  padding: '10px 16px', borderRadius: 10, cursor: 'pointer',
                  border: etabSelectionne === etab.id ? '2px solid #EA580C' : '2px solid #E2E8F0',
                  background: etabSelectionne === etab.id ? '#FFF7ED' : 'white',
                  display: 'flex', alignItems: 'center', gap: 8
                }}>
                  <span style={{ fontSize: 22 }}>{cfg.icon}</span>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13 }}>{etab.nom}</div>
                    <div style={{ color: '#64748B', fontSize: 11 }}>{cfg.label}</div>
                  </div>
                  {etabSelectionne === etab.id && <span style={{ color: '#EA580C' }}>✓</span>}
                </div>
              );
            })}
          </div>
        </div>

        {/* ── LISTE ── */}
        {vue === 'liste' && etabSelectionne && (
          <>
            <div style={styles.filtres}>
              <input
                type="text" placeholder={'Rechercher dans ' + config.label + '...'}
                value={recherche} onChange={(e) => setRecherche(e.target.value)}
                style={styles.rechercheInput}
              />
              <span style={{ color: '#64748B', fontSize: 13 }}>{produitsFiltres.length + ' produit(s)'}</span>
            </div>

            <div style={styles.section}>
              {produitsFiltres.length === 0 ? (
                <div style={styles.vide}>
                  <div style={{ fontSize: 60 }}>{config.icon}</div>
                  <p style={{ fontWeight: 700, fontSize: 16, marginTop: 12 }}>Aucun produit</p>
                  <p style={{ color: '#94A3B8', fontSize: 13 }}>Cliquez sur "+ Nouveau Produit" pour commencer</p>
                </div>
              ) : (
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      {['', 'Produit', 'Catégorie', 'Prix', 'Stock', 'Seuil', 'Statut', 'Actions'].map((h, i) => (
                        <th key={i} style={styles.th}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {produitsFiltres.map((p, i) => {
                      const statut = p.quantite === 0 ? 'rupture' : p.quantite <= p.seuil_alerte ? 'alerte' : 'normal';
                      const sc = {
                        rupture: { label: 'Rupture', couleur: '#DC2626', bg: '#FEF2F2' },
                        alerte: { label: 'Alerte', couleur: '#EA580C', bg: '#FFF7ED' },
                        normal: { label: 'Normal', couleur: '#059669', bg: '#ECFDF5' },
                      };
                      return (
                        <tr key={i} style={{ background: i % 2 === 0 ? '#F8FAFC' : 'white' }}>
                          <td style={styles.td}>
                            {p.image_principale ? (
                              <img src={SERVER_URL + '/uploads/produits/' +
                                p.image_principale.replace(/\\/g, '/').split('/').pop()}
                                alt="produit"
                                style={{ width: 44, height: 44, borderRadius: 8, objectFit: 'cover' }} />
                            ) : (
                              <div style={{
                                width: 44, height: 44, borderRadius: 8, background: config.bg,
                                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22
                              }}>{config.icon}</div>
                            )}
                          </td>
                          <td style={styles.td}>
                            <div style={{ fontWeight: 700 }}>{p.nom}</div>
                            <div style={{ color: '#64748B', fontSize: 11 }}>{p.unite}</div>
                          </td>
                          <td style={styles.td}>
                            {p.categorie ? (
                              <span style={{
                                padding: '3px 8px', borderRadius: 6, fontSize: 11,
                                background: config.bg, color: config.couleur, fontWeight: 700
                              }}>{p.categorie}</span>
                            ) : '—'}
                          </td>
                          <td style={styles.td}>
                            <span style={{ fontWeight: 700, color: '#2563EB' }}>
                              {fmtF(parseInt(p.prix))}
                            </span>
                          </td>
                          <td style={styles.td}>
                            <span style={{
                              fontWeight: 700, fontSize: 18,
                              color: statut === 'rupture' ? '#DC2626' : statut === 'alerte' ? '#EA580C' : '#059669'
                            }}>{p.quantite}</span>
                            <span style={{ color: '#64748B', fontSize: 11 }}>{' ' + p.unite}</span>
                          </td>
                          <td style={styles.td}>{p.seuil_alerte}</td>
                          <td style={styles.td}>
                            <span style={{
                              padding: '4px 10px', borderRadius: 12, fontSize: 12, fontWeight: 700,
                              background: sc[statut].bg, color: sc[statut].couleur
                            }}>{sc[statut].label}</span>
                          </td>
                          <td style={styles.td}>
                            <div style={{ display: 'flex', gap: 6 }}>
                              <button onClick={() => handleModifier(p)} style={styles.btnModifier} title="Modifier" aria-label="Modifier"><LuPencil aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                              <button onClick={() => { setModalAppro(p); setQteAppro(''); setMotifAppro(''); }}
                                style={styles.btnAppro} title="Approvisionner" aria-label="Approvisionner"><LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                              <button onClick={() => { setModalPerte(p); setQtePerte(''); setMotifPerte(''); }}
                                style={styles.btnPerte} title="Perte" aria-label="Perte"><LuMinus aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </>
        )}

        {/* ── FORMULAIRE INTELLIGENT EN ÉTAPES ── */}
        {vue === 'formulaire' && (
          <div style={styles.formCard}>

            {/* BADGE SECTEUR */}
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 16px', borderRadius: 20, marginBottom: 20,
              background: config.bg, color: config.couleur, fontWeight: 700, fontSize: 14
            }}>
              {config.icon} {config.label} — {etabActuel?.nom}
            </div>

            <h2 style={styles.formTitre}>
              {produitSelectionne ? 'Modifier : ' + produitSelectionne.nom : 'Nouveau Produit'}
            </h2>

            {/* INDICATEUR ÉTAPES */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
              {['Infos', 'Détails', 'Image'].map((e, i) => (
                <div key={i} onClick={() => setEtape(i + 1)} style={{
                  flex: 1, padding: '8px', borderRadius: 8, textAlign: 'center',
                  cursor: 'pointer', fontSize: 13, fontWeight: 700,
                  background: etape === i + 1 ? config.couleur : '#F8FAFC',
                  color: etape === i + 1 ? 'white' : '#64748B',
                  border: etape === i + 1 ? 'none' : '1px solid #E2E8F0'
                }}>{i + 1}. {e}</div>
              ))}
            </div>

            <form onSubmit={handleSubmit}>

              {/* ÉTAPE 1 — INFOS DE BASE */}
              {etape === 1 && (
                <div>
                  <div style={styles.champGros}>
                    <label style={styles.labelGros}>Nom du produit *</label>
                    <input type="text" value={form.nom}
                      onChange={(e) => setForm({ ...form, nom: e.target.value })}
                      style={styles.inputGros}
                      placeholder={'Ex: ' + config.categories[0]} required />
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                    <div style={styles.champGros}>
                      <label style={styles.labelGros}><LuWallet aria-hidden style={{ verticalAlign: '-0.125em' }} /> Prix (FCFA) *</label>
                      <input type="number" min="0" value={form.prix}
                        onChange={(e) => setForm({ ...form, prix: e.target.value })}
                        style={styles.inputGros} placeholder="Ex: 500" required />
                    </div>
                    <div style={styles.champGros}>
                      <label style={styles.labelGros}><LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /> Catégorie</label>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
                        {config.categories.map(c => (
                          <button key={c} type="button"
                            onClick={() => setForm({ ...form, categorie: c })}
                            style={{
                              padding: '6px 12px', borderRadius: 20, border: 'none',
                              cursor: 'pointer', fontSize: 12, fontWeight: 700,
                              background: form.categorie === c ? config.couleur : '#F8FAFC',
                              color: form.categorie === c ? 'white' : '#475569'
                            }}>{c}</button>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
                    <div style={styles.champGros}>
                      <label style={styles.labelGros}><LuRuler aria-hidden style={{ verticalAlign: '-0.125em' }} /> Unité</label>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
                        {config.unites.map(u => (
                          <button key={u} type="button"
                            onClick={() => setForm({ ...form, unite: u })}
                            style={{
                              padding: '6px 12px', borderRadius: 20, border: 'none',
                              cursor: 'pointer', fontSize: 12, fontWeight: 700,
                              background: form.unite === u ? 'var(--accent)' : '#F1F5F9',
                              color: form.unite === u ? 'white' : '#475569'
                            }}>{u}</button>
                        ))}
                      </div>
                    </div>
                    <div style={styles.champGros}>
                      <label style={styles.labelGros}><LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /> Quantité {!produitSelectionne ? '*' : ''}</label>
                      <input type="number" min="0" value={form.quantite}
                        onChange={(e) => setForm({ ...form, quantite: e.target.value })}
                        style={styles.inputGros} placeholder="Ex: 100"
                        required={!produitSelectionne} />
                      {produitSelectionne && (
                        <div style={{ color: '#2563EB', fontSize: 11, marginTop: 4 }}>
                          <LuLightbulb aria-hidden style={{ verticalAlign: '-0.125em' }} /> Utilisez <LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /> ou <LuMinus aria-hidden style={{ verticalAlign: '-0.125em' }} /> depuis la liste
                        </div>
                      )}
                    </div>
                    <div style={styles.champGros}>
                      <label style={styles.labelGros}><LuTriangleAlert aria-hidden style={{ verticalAlign: '-0.125em' }} /> Seuil alerte *</label>
                      <input type="number" min="0" value={form.seuil_alerte}
                        onChange={(e) => setForm({ ...form, seuil_alerte: e.target.value })}
                        style={styles.inputGros} placeholder="Ex: 10" required />
                    </div>
                  </div>

                  <div style={styles.champGros}>
                    <label style={styles.labelGros}><LuFileText aria-hidden style={{ verticalAlign: '-0.125em' }} /> Description (optionnel)</label>
                    <textarea value={form.description}
                      onChange={(e) => setForm({ ...form, description: e.target.value })}
                      style={{ ...styles.inputGros, height: 70, resize: 'none' }}
                      placeholder="Description courte..." />
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                    <button type="button" onClick={() => setEtape(2)} style={styles.btnSuivant}>
                      Suivant → {config.icon} Détails
                    </button>
                  </div>
                </div>
              )}

              {/* ÉTAPE 2 — DÉTAILS SPÉCIFIQUES */}
              {etape === 2 && (
                <div>
                  {config.champs.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: 40, color: '#64748B' }}>
                      <div style={{ fontSize: 48 }}>{config.icon}</div>
                      <p style={{ marginTop: 12 }}>Aucun champ spécifique pour ce secteur</p>
                      <p style={{ fontSize: 13, color: '#94A3B8' }}>Passez directement à l'image</p>
                    </div>
                  ) : (
                    <>
                      <div style={{
                        background: config.bg, borderRadius: 12, padding: '12px 16px',
                        marginBottom: 20, color: config.couleur, fontWeight: 700
                      }}>
                        {config.icon} Caractéristiques spécifiques {config.label}
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                        {config.champs.map((champ, i) => (
                          <div key={i} style={styles.champGros}>
                            <label style={styles.labelGros}>
                              {champ.icon} {champ.nom}
                            </label>
                            <input type="text"
                              value={champsExtra[champ.nom] || ''}
                              onChange={(e) => setChampsExtra({ ...champsExtra, [champ.nom]: e.target.value })}
                              style={styles.inputGros}
                              placeholder={champ.placeholder} />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
                    <button type="button" onClick={() => setEtape(1)} style={styles.btnPrecedent}>
                      ← Retour
                    </button>
                    <button type="button" onClick={() => setEtape(3)} style={styles.btnSuivant}>
                      Suivant → <LuCamera aria-hidden style={{ verticalAlign: '-0.125em' }} /> Image
                    </button>
                  </div>
                </div>
              )}

              {/* ÉTAPE 3 — IMAGE + VALIDATION */}
              {etape === 3 && (
                <div>
                  <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <div style={styles.imageBoxGrande}>
                      {imagePreview ? (
                        <img src={imagePreview} alt="produit"
                          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 16 }} />
                      ) : (
                        <div style={{ color: '#64748B' }}>
                          <div style={{ fontSize: 60 }}>{config.icon}</div>
                          <p style={{ marginTop: 8, fontSize: 14 }}>Cliquer pour ajouter une photo</p>
                          <p style={{ fontSize: 12, color: '#94A3B8' }}>JPG, PNG — Max 2 MB</p>
                        </div>
                      )}
                      <input type="file" accept="image/*"
                        onChange={(e) => {
                          const f = e.target.files[0];
                          if (f) { setImageFichier(f); setImagePreview(URL.createObjectURL(f)); }
                        }}
                        style={styles.photoInput} />
                    </div>
                    {imagePreview && (
                      <button type="button"
                        onClick={() => { setImagePreview(null); setImageFichier(null); }}
                        style={{ marginTop: 8, background: 'none', border: 'none', color: '#DC2626', cursor: 'pointer', fontSize: 13 }}>
                        <LuTrash2 aria-hidden style={{ verticalAlign: '-0.125em' }} /> Supprimer l'image
                      </button>
                    )}
                  </div>

                  {/* RÉCAPITULATIF */}
                  <div style={{ background: config.bg, borderRadius: 12, padding: 16, marginBottom: 20 }}>
                    <div style={{ fontWeight: 700, color: config.couleur, marginBottom: 8 }}>
                      <LuCircleCheck aria-hidden style={{ verticalAlign: '-0.125em' }} /> Récapitulatif
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, fontSize: 13 }}>
                      <div><span style={{ color: '#64748B' }}>Nom : </span><strong>{form.nom || '—'}</strong></div>
                      <div><span style={{ color: '#64748B' }}>Prix : </span><strong>{form.prix ? fmtF(parseInt(form.prix)) : '—'}</strong></div>
                      <div><span style={{ color: '#64748B' }}>Catégorie : </span><strong>{form.categorie || '—'}</strong></div>
                      <div><span style={{ color: '#64748B' }}>Unité : </span><strong>{form.unite || '—'}</strong></div>
                      {!produitSelectionne && (
                        <div><span style={{ color: '#64748B' }}>Quantité : </span><strong>{form.quantite || '0'}</strong></div>
                      )}
                      <div><span style={{ color: '#64748B' }}>Seuil alerte : </span><strong>{form.seuil_alerte || '5'}</strong></div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button type="button" onClick={() => setEtape(2)} style={styles.btnPrecedent}>
                      ← Retour
                    </button>
                    <button type="submit" style={styles.btnValider}>
                      {produitSelectionne ? 'Sauvegarder les modifications' : 'Créer le produit'}
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        )}

        {/* MODAL APPRO */}
        {modalAppro && (
          <div style={styles.overlay}>
            <div style={styles.modal}>
              <h3 style={{ color: '#059669', marginBottom: 8 }}><LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Approvisionner</h3>
              <p style={{ fontWeight: 700, marginBottom: 4 }}>{modalAppro.nom}</p>
              <p style={{ color: '#64748B', fontSize: 13, marginBottom: 16 }}>
                Stock actuel : <strong style={{ color: '#059669' }}>{modalAppro.quantite} {modalAppro.unite}</strong>
              </p>
              <div style={styles.champGros}>
                <label style={styles.labelGros}>Quantité à ajouter *</label>
                <input type="number" min="1" value={qteAppro}
                  onChange={(e) => setQteAppro(e.target.value)}
                  style={styles.inputGros} placeholder="Ex: 50" />
              </div>
              <div style={{ ...styles.champGros, marginTop: 12 }}>
                <label style={styles.labelGros}>Motif</label>
                <input type="text" value={motifAppro}
                  onChange={(e) => setMotifAppro(e.target.value)}
                  style={styles.inputGros} placeholder="Livraison fournisseur..." />
              </div>
              <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                <button onClick={() => setModalAppro(null)} style={styles.btnPrecedent}>Annuler</button>
                <button onClick={handleApprovisionner} style={{
                  ...styles.btnValider, background: '#059669'
                }}><LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Confirmer</button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL PERTE */}
        {modalPerte && (
          <div style={styles.overlay}>
            <div style={styles.modal}>
              <h3 style={{ color: '#DC2626', marginBottom: 8 }}><LuMinus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Enregistrer une Perte</h3>
              <p style={{ fontWeight: 700, marginBottom: 4 }}>{modalPerte.nom}</p>
              <p style={{ color: '#64748B', fontSize: 13, marginBottom: 16 }}>
                Stock actuel : <strong style={{ color: '#DC2626' }}>{modalPerte.quantite} {modalPerte.unite}</strong>
              </p>
              <div style={styles.champGros}>
                <label style={styles.labelGros}>Quantité perdue *</label>
                <input type="number" min="1" max={modalPerte.quantite} value={qtePerte}
                  onChange={(e) => setQtePerte(e.target.value)}
                  style={styles.inputGros} placeholder="Ex: 5" />
              </div>
              <div style={{ ...styles.champGros, marginTop: 12 }}>
                <label style={styles.labelGros}>Motif *</label>
                <input type="text" value={motifPerte}
                  onChange={(e) => setMotifPerte(e.target.value)}
                  style={styles.inputGros} placeholder="Produit périmé, casse..." />
              </div>
              <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                <button onClick={() => setModalPerte(null)} style={styles.btnPrecedent}>Annuler</button>
                <button onClick={handlePerte} style={{
                  ...styles.btnValider, background: '#DC2626'
                }}><LuMinus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Confirmer</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AppLayout>
  );
}

const styles = {
  chargement: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: 24, color: '#475569' },
  contenu: { ...S.contenu, flex: 1 },
  messageBox: { ...S.messageBox, marginBottom: 16 },
  header: S.header,
  headerTitre: S.headerTitre,
  headerSousTitre: S.headerSousTitre,
  boutonAjouter: S.boutonAjouter,
  boutonRetour: S.boutonRetour,
  etabSelector: { ...S.etabSelector, marginBottom: 20 },
  etabSelectorTitre: { ...S.etabSelectorTitre, marginBottom: 10 },
  filtres: { ...S.filtres, marginBottom: 16 },
  rechercheInput: { ...S.rechercheInput },
  section: S.section,
  vide: S.vide,
  table: { ...S.table, width: '100%' },
  tableHeader: S.tableHeader,
  th: S.th,
  td: S.td,
  btnModifier: S.btnModifier,
  btnAppro: S.btnAppro,
  btnPerte: S.btnPerte,
  formCard: S.formCard,
  formTitre: { ...S.formTitre, marginBottom: 20 },
  champGros: { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 },
  labelGros: { fontSize: 14, fontWeight: '700', color: '#1E293B' },
  inputGros: { padding: '14px 16px', borderRadius: 12, border: '2px solid #E2E8F0', fontSize: 15, outline: 'none', width: '100%', boxSizing: 'border-box', transition: 'border 0.2s' },
  imageBoxGrande: { width: 200, height: 200, borderRadius: 16, border: '3px dashed #E2E8F0', overflow: 'hidden', cursor: 'pointer', position: 'relative', background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' },
  photoInput: { position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer', width: '100%', height: '100%' },
  btnSuivant: { padding: '12px 24px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 14 },
  btnPrecedent: { padding: '12px 24px', background: '#F8FAFC', color: '#475569', border: '1px solid #E2E8F0', borderRadius: 10, cursor: 'pointer', fontSize: 14 },
  btnValider: S.btnValider,
  overlay: S.overlay,
  modal: { ...S.modal, width: 'min(420px, 100%)' },
};